'use client';

import {Course} from '@udemy-v2/browse-course';
import {LinkGroup} from '@udemy-v2/react-structure-components';
import {useI18n} from '@udemy-v2/i18n';
import classNames from 'classnames';
import styles from './related-topics.module.scss';
import {publishEvent} from '@udemy-v2/event-tracking';
import {
    BrowseNavigationItemType,
    BrowseNavigationItemStyle,
    BrowseNavigationItemSelected,
} from '../../events/browse-navigation-item-selected';
import {CLPNavigationItem, useCLPNavigationContext} from './hooks/use-clp-navigation-context';

interface RelatedTopicsProps {
    course: Course;
}

export function RelatedTopics({course}: RelatedTopicsProps) {
    const {gettext} = useI18n();
    const topicNavigationContext = useCLPNavigationContext(course, [
        BrowseNavigationItemType.BADGE,
    ]);

    if (!topicNavigationContext.length) {
        return null;
    }

    return (
        <div>
            <div className={styles['topic-navigation']}>
                <h2 className={classNames(styles.title, 'ud-heading-xl')}>
                    {gettext('Explore related topics')}
                </h2>
                <LinkGroup ariaLabel={gettext('Explore related topics')}>
                    {topicNavigationContext.map(
                        (navigationItem: CLPNavigationItem, index: number) => {
                            return (
                                <LinkGroup.Item
                                    href={navigationItem.url}
                                    key={index}
                                    onClick={() => {
                                        publishEvent(
                                            new BrowseNavigationItemSelected({
                                                id: navigationItem.id,
                                                type: navigationItem.type,
                                                uiRegion: 'browse_navigation',
                                                style: BrowseNavigationItemStyle.PILL_LIGHT,
                                            }),
                                        );
                                    }}
                                >
                                    {navigationItem.title}
                                </LinkGroup.Item>
                            );
                        },
                    )}
                </LinkGroup>
            </div>
        </div>
    );
}
